<div fxLayout="row" telemetry="DateTime picker">
    <div fxLayout="column">
        <forge-date-picker [attr.min]="minDate" [attr.max]="maxDate" show-today class="tt-margin--right">
            <forge-text-field #pickerTextField [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}"
                [density]="density" [attr.label-position]="LabelPosition" [attr.shape]="forCellEdit ? 'squared' : null">
        <input #input [id]="dateControlId" type="text" focusOnLoad [propertyMetadata]="propertyMetadata" [forCellEdit]="forCellEdit"
                    [forCellEdit]="forCellEdit" [disabled]="isViewOnly" [required]="isRequired" [(ngModel)]="dateValue"
                    (blur)="fireValueChanged()" (input)="onInputChange($event)" [attr.telemetry]="telemeteryName"
                    [name]="Name" (keydown)="onKeyDown($event)">
          <label [for]="dateControlId">{{DateLabel}}</label>
                @if (hint && !dense && !compact) {
                <span slot="support-text">{{hint}}</span>
                }
                @if (error && !dense && !compact) {
                <span slot="support-text" class="error-red">{{error}}</span>
                }
                @if (showSpinner) {
                <forge-circular-progress class="metadata-input--spinner" slot="end">
                </forge-circular-progress>
                }
            </forge-text-field>
        </forge-date-picker>
    </div>

    <div fxLayout="column">
        <forge-time-picker step="10" [disabled]="isViewOnly" [attr.allow-seconds]="allowSeconds">
            <forge-text-field [density]="density" [attr.label-position]="LabelPosition"
                [attr.shape]="forCellEdit ? 'squared' : null"
                [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}">
          <input [id]="timeControlId" type="text" focusOnLoad [propertyMetadata]="propertyMetadata" [forCellEdit]="forCellEdit"
                    [forCellEdit]="forCellEdit" [(ngModel)]="timeValue" [disabled]="isViewOnly" [required]="isRequired"
                    (blur)="fireValueChanged()" (input)="onInputChange($event)" [attr.telemetry]="timeTelemeteryName"
                    name="{{Name}}.time" placeholder="hh:mm AM" (keydown)="onKeyDown($event)">
            <label [for]="timeControlId">{{TimeLabel}}</label>
                @if (hint && !dense && !compact) {
                <span slot="support-text">{{hint}}</span>
                }
                @if (error && !dense && !compact) {
                <span slot="support-text" class="error-red">{{error}}</span>
                }
                @if (showSpinner) {
                <forge-circular-progress class="metadata-input--spinner" slot="end">
                </forge-circular-progress>
                }
            </forge-text-field>
        </forge-time-picker>
    </div>
</div>